export default {
      id: "icon-copy-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "img/icons.33fd9142.svg#icon-copy",
      toString: function () {
        return this.url;
      }
    }